{
  "deep_search.advanced_no_suggestions": "Keine Vorschläge",
  "deep_search.advanced_no_suggestions_hint": "Feldname eingeben oder Beispiel wählen",
  "deep_search.advanced_placeholder": "Dokumente suchen… z. B. Name:invoice Tag:invoice FileSize:>1000",
  "deep_search.attr.doc.Currency": "Währung",
  "deep_search.attr.doc.CustomerCity": "Kundenort",
  "deep_search.attr.doc.CustomerCountry": "Kundenland",
  "deep_search.attr.doc.CustomerName": "Kundenname",
  "deep_search.attr.doc.CustomerZip": "Kunden-PLZ",
  "deep_search.attr.doc.DocumentLanguage": "Sprache",
  "deep_search.attr.doc.DocumentTitle": "Dokumenttitel",
  "deep_search.attr.doc.DocumentType": "Dokumententyp",
  "deep_search.attr.doc.DueDate": "Fälligkeitsdatum",
  "deep_search.attr.doc.InvoiceDate": "Belegdatum",
  "deep_search.attr.doc.InvoiceNumber": "Belegnummer",
  "deep_search.attr.doc.InvoicePeriodFrom": "Zeitraum von",
  "deep_search.attr.doc.InvoicePeriodTo": "Zeitraum bis",
  "deep_search.attr.doc.PurchaseOrderNumber": "Bestellungsnummer",
  "deep_search.attr.doc.TotalInclVat": "Total inkl. MWST",
  "deep_search.attr.doc.VendorCity": "Lieferantenort",
  "deep_search.attr.doc.VendorCountry": "Lieferantenland",
  "deep_search.attr.doc.VendorName": "Lieferantenname",
  "deep_search.attr.doc.VendorZip": "Lieferanten-PLZ",
  "deep_search.attr.Assignee": "Zugewiesen",
  "deep_search.boolean_and_subtitle": "Require both sides",
  "deep_search.boolean_close_group": "Close group",
  "deep_search.boolean_negate": "Negate next qualifier or term",
  "deep_search.boolean_not_subtitle": "Exclude following term",
  "deep_search.boolean_open_group": "Open group",
  "deep_search.boolean_or_subtitle": "Match either side",
  "deep_search.common_apply": "Übernehmen",
  "deep_search.common_back": "Zurück",
  "deep_search.common_save": "Speichern",
  "deep_search.date_picker_bare_date_hint": "Bare dates match the whole day in the active timezone (default Europe/Zurich).",
  "deep_search.date_picker_include_time": "Uhrzeit einschliessen",
  "deep_search.date_picker_utc": "UTC",
  "deep_search.date_picker_utc_date_only_hint": "Calendar date (UTC). Matches the whole UTC day; unaffected by tz:.",
  "deep_search.detail_clear": "Löschen",
  "deep_search.error.DANGLING_OPERATOR": "Unvollständiger Operator in der Abfrage ({operator})",
  "deep_search.error.DUPLICATE_SORT_KEY": "Doppeltes Sortierfeld: {key}",
  "deep_search.error.EMPTY_VALUE": "sort: erfordert mindestens ein Feld",
  "deep_search.error.INVALID_ATTRIBUTE_KEY": "Nach diesem Attribut kann nicht sortiert werden: {key}",
  "deep_search.error.INVALID_TIMEZONE": "Unbekannte Zeitzone: {zone}",
  "deep_search.error.INVALID_VALUE_FORMAT": "Vollständiges Kalenderdatum verwenden (YYYY-MM-DD)",
  "deep_search.error.INVALID_WILDCARD": "Führende Wildcards werden nicht unterstützt",
  "deep_search.error.MISPLACED_DIRECTIVE": "sort: und tz: müssen am Ende der Abfrage stehen",
  "deep_search.error.QUERY_TOO_COMPLEX": "Diese Abfrage ist zu komplex",
  "deep_search.error.UNBALANCED_BRACES": "Unausgeglichene Klammern in der Abfrage",
  "deep_search.error.VALIDATION_ERROR": "Ungültige Suchabfrage",
  "deep_search.field.CreatedTime": "Erstellt",
  "deep_search.field.CreatedUser": "Erstellt von",
  "deep_search.field.FileSize": "Dateigrösse",
  "deep_search.field.Kind": "Art",
  "deep_search.field.ModifiedTime": "Geändert",
  "deep_search.field.ModifiedUser": "Geändert von",
  "deep_search.field.Name": "Name",
  "deep_search.field.OwnerUser": "Besitzer",
  "deep_search.field.Tag": "Tag",
  "deep_search.field.Type": "Typ",
  "deep_search.filters_all": "Alle",
  "deep_search.filters_clear_selected": "Auswahl löschen",
  "deep_search.filters_select_all": "Alle Filter auswählen",
  "deep_search.filters_contains_placeholder": "Enthält Text",
  "deep_search.filters_enter_value": "{label} eingeben…",
  "deep_search.filters_find_criteria": "Kriterium finden…",
  "deep_search.filters_find_sort": "Sortierung finden…",
  "deep_search.filters_find_value": "{label} finden…",
  "deep_search.filters_loading_options": "Optionen werden geladen…",
  "deep_search.filters_mode_date": "Datum / Bereich",
  "deep_search.filters_mode_number": "Zahl / Bereich",
  "deep_search.filters_mode_options": "Wert wählen",
  "deep_search.filters_mode_text": "Text",
  "deep_search.filters_more": "Mehr",
  "deep_search.filters_others": "(+ {count} weitere)",
  "deep_search.filters_no_matching_criteria": "Keine passenden Kriterien",
  "deep_search.filters_number_range": "Zahlenbereich…",
  "deep_search.filters_pick_date": "Datum wählen…",
  "deep_search.filters_pick_date_range": "Datumsbereich wählen…",
  "deep_search.filters_sort_label": "Sortierung:",
  "deep_search.filters_sort_relevance": "Relevanz (Standard)",
  "deep_search.filters_use_value": "„{value}“ verwenden",
  "deep_search.menu_all": "Alle",
  "deep_search.menu_find": "Suchen…",
  "deep_search.menu_no_matching": "Keine passenden Optionen",
  "deep_search.number_range_from": "Von",
  "deep_search.number_range_preset_0_up": "0 und aufwärts",
  "deep_search.number_range_preset_100_500": "100 – 500",
  "deep_search.number_range_preset_1k_5k": "1,000 – 5.000",
  "deep_search.number_range_preset_up_to_1k": "Bis zu 1.000",
  "deep_search.number_range_presets": "Voreinstellungen",
  "deep_search.number_range_to": "Bis",
  "deep_search.options_load_failed": "Filteroptionen konnten nicht geladen werden",
  "deep_search.relative_14d": "vor 14 Tagen",
  "deep_search.relative_1h": "vor 1 Stunde",
  "deep_search.relative_24h": "vor 24 Stunden",
  "deep_search.relative_30d": "vor 30 Tagen",
  "deep_search.relative_7d": "vor 7 Tagen",
  "deep_search.save_dialog_cancel": "Abbrechen",
  "deep_search.save_dialog_confirm": "Speichern",
  "deep_search.save_dialog_confirm_create": "Suche speichern",
  "deep_search.save_dialog_edit_subtitle": "Aktualisieren Sie den Namen oder die verknüpfte Ansicht. Die Abfrage wird zur Orientierung angezeigt.",
  "deep_search.save_dialog_edit_title": "Suche bearbeiten",
  "deep_search.save_dialog_name": "Suchname",
  "deep_search.save_dialog_name_required": "Namen eingeben",
  "deep_search.save_dialog_query": "Abfrage",
  "deep_search.save_dialog_subtitle": "Speichern Sie die aktuelle Suche für späteren Schnellzugriff.",
  "deep_search.save_dialog_table_options": "Individuelle Spalten",
  "deep_search.save_dialog_table_options_hint": "Diese Spaltenauswahl wird mit der Suche gespeichert. Entfernen, um stattdessen die Spalten der Ansicht zu verwenden.",
  "deep_search.save_dialog_title": "Suche speichern",
  "deep_search.save_dialog_variant": "Suchmodus",
  "deep_search.save_dialog_view": "Ansicht",
  "deep_search.save_dialog_view_hint": "Entfernen, um die Suche in der aktuell geöffneten Ansicht anzuwenden.",
  "deep_search.sort_created_newest": "Erstellt (neueste)",
  "deep_search.sort_file_size_largest": "Dateigrösse (grösste)",
  "deep_search.sort_modified_newest": "Geändert (neueste)",
  "deep_search.sort_modified_oldest": "Geändert (älteste)",
  "deep_search.sort_name_az": "Name (A–Z)",
  "deep_search.sort_relevance": "Relevanz",
  "deep_search.suggestion_absolute_date": "Absolutes Datum",
  "deep_search.suggestion_date_range": "Datumsbereich",
  "deep_search.suggestion_number_range": "Zahlenbereich",
  "deep_search.variant_advanced": "Erweitert",
  "deep_search.variant_incompatible_boolean": "Diese Abfrage nutzt boolesche Operatoren — zu Advanced wechseln",
  "deep_search.variant_incompatible_complex": "Diese Abfrage ist zu komplex für Einfach — zu Advanced wechseln",
  "deep_search.variant_incompatible_grouping": "Diese Abfrage nutzt Gruppierung/Verschachtelung — zu Advanced wechseln",
  "deep_search.variant_simple": "Einfach",
  "deep_search.location_everywhere": "Überall in {location}",
  "deep_search.location_current": "Aktuell: {location}",
  "deep_search.location_more": "Weitere Orte…",
  "deep_search.location_select_title": "Ort auswählen",
  "deep_search.location_clear": "Gesamte Box durchsuchen",
  "deep_search.location_reset_default": "Zur Standardposition zurücksetzen",
  "deep_search.table_header_location": "Standort",
  "deep_search.search_in_location": "In \"{location}\" suchen…",
  "deep_search.quick_show_all": "Alle Ergebnisse anzeigen",
  "deep_search.quick_no_results": "Keine Ergebnisse",
  "deep_search.quick_modified_by": "Geändert von {user} · {when}"
}
